module.exports = "pegasus_template/assets/blocks/header-9-tech.png";